module.exports = __webpack_public_path__ + "img/서브2_공제어감각.305958de.svg";